export enum PageType {
  RECRUIT_MEMBERSHIP = 'recruit_membership',
  ORDER_HISTORY = 'order_history'
}
